<button type="button" class="icon-alertRNDC" [ngClass]="{'icon-alertRNDC--active': rndcTrigger.menuOpen}"
    [matMenuTriggerFor]="rndcMenu" #rndcTrigger="matMenuTrigger"
    matTooltip="Plan de contingencia activado" matTooltipPosition="below" matTooltipClass="rndc-contingency-tooltip"
    aria-label="Abrir plan de contingencia RNDC">
    <i class="fas fa-exclamation-triangle"></i>
    <span class="icon-alertRNDC__label">RNDC</span>
</button>

<mat-menu #rndcMenu="matMenu" class="container-rndc-alert" panelClass="container-rndc-alert"
    xPosition="before" [overlapTrigger]="false">
    <div class="box-alertRNDC">
        <div class="header-alertRNDC">
            <div class="d-flex align-items-center">
                <i class="fas fa-exclamation-triangle icon"></i>
                <span class="text-bold text-alertRNDC">Plan de contingencia activado</span>
            </div>
        </div>
        <div class="body-alertRNDC">
            <p class="mt-3">Las siguientes operaciones no se emitirán al RNDC:</p>
            <ul>
                <li class="text-bold">Creación de vehículos</li>
                <li class="text-bold">Creación de usuarios (conductores, propietarios, administradores)</li>
                <li class="text-bold">Creación de terceros y direcciones de terceros</li>
                <li class="text-bold">Generación de manifiestos</li>
                <li class="text-bold">Generación de remesas</li>
                <li class="text-bold">Cumplimiento de manifiestos y remesas</li>
            </ul>
        </div>
    </div>
</mat-menu>
